module.exports = __webpack_public_path__ + "img/visa.4cb5fa8f.png";